import { Component, inject, Input, OnInit } from '@angular/core';
import { EdiHistoryService } from '../../../../services/edi-history.service';
import { EdiHistory } from '../../../../models/edi-history.model';
import { mapAsBody } from '../../util/request-util';
import dayjs from 'dayjs';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-transport-edi-history',
  templateUrl: './transport-edi-history.component.html',
  styleUrls: ['./transport-edi-history.component.scss'],
})
export class TransportEdiHistoryComponent implements OnInit {
  private readonly ediHistoryService = inject(EdiHistoryService);

  @Input() transportOrderId?: number;
  @Input() ediId?: string;

  public ediHistories: EdiHistory[] = [];
  public displayDownloadEdiFile = true;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    this.displayEdiFile();

    if (this.transportOrderId) {
      this.ediHistoryService
        .findAllForTransportOrder(this.transportOrderId)
        .pipe(mapAsBody)
        .subscribe(ediHistories => {
          // recherche du transporter en cours var l'objet transporter dans ediHistories ne contient que l'id du transporter:
          this.ediHistories = ediHistories ?? [];
        });
    }
  }

  public writeLine(ediHistory: EdiHistory, index: number): string {
    if (index === 0) {
      return 'Envoyé le ' + dayjs(ediHistory.date).format('DD/MM/YYYY') + ' par ' + ediHistory.author?.toUpperCase();
    } else {
      return 'Renvoyé le ' + dayjs(ediHistory.date).format('DD/MM/YYYY') + ' par ' + ediHistory.author?.toUpperCase();
    }
  }

  public downloadEdiFile(ediHistory: EdiHistory): void {
    const splits = ediHistory.filePath!.split('/');
    this.ediHistoryService.download(ediHistory.id!, splits[splits.length - 1]);
  }

  private displayEdiFile(): boolean {
    let displayIcon = true;
    if (this.ediId?.match(/^([0-9][0-9][0-9])-([0-9][0-9][0-9])-([0-9][0-9][0-9][0-9])$/)) {
      displayIcon = false;
    }
    return displayIcon;
  }
}
